import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ManageRuleSets.css";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const ManageRuleSets = () => {
  const navigate = useNavigate();
  const { rulesetId: rulesetName } = useParams();
  const [ruleset, setRuleset] = useState({ name: "", description: "", action: "" });
  const [availableRules, setAvailableRules] = useState([]);
  const [rulesInRuleset, setRulesInRuleset] = useState([]);
  const [selectedAvailableRules, setSelectedAvailableRules] = useState([]);
  const [selectedRulesInRuleset, setSelectedRulesInRuleset] = useState([]);
  const [searchAvailable, setSearchAvailable] = useState("");
  const [searchInRuleset, setSearchInRuleset] = useState("");
  const [initialState, setInitialState] = useState({});
  // ✅ State to track hover effect
  const [isCancelHovered, setCancelHovered] = useState(false);
  const [isSubmitHovered, setSubmitHovered] = useState(false);

  const allowedActions = ["Block Transaction", "Queue", "Monitor", "Flag for Review"];

 useEffect(() => {
  if (rulesetName) {
    fetchRuleset(rulesetName); // Fetch data for edit mode
  } else {
    initializeCreateMode(); // Initialize form for create mode
  }
  fetchAvailableRules(); // Fetch rules for both create and edit modes
}, [rulesetName]);

  const getSubscriberId = async () => {
  try {
    const token = localStorage.getItem("access_token") || sessionStorage.getItem("access_token") || Cookies.get("access_token");
    if (!token) {
      console.error("❌ No access token found.");
      return null;
    }

    const payload = JSON.parse(atob(token.split(".")[1])); // Decode JWT payload
    const tenantId = payload.tenant_id || payload.subscriber_name; // Extract tenant_id

    if (!tenantId) {
      console.error("❌ tenant_id/subscriber_name missing in token.");
      return null;
    }

    console.log(`✅ Extracted tenant_id: ${tenantId}`);

    // ✅ Fetch subscriber_id from backend synchronously
    const response = await axios.get(` /composite-backend/internal/ui/rules/get-subscriber-id?tenant_id=${tenantId}`);
    return response.data.subscriber_id;
  } catch (error) {
    console.error("❌ Error retrieving subscriber_id:", error);
    return null;
  }
};

  const fetchRuleset = async (name) => {
  try {
    
    const subscriberId = getSubscriberId();
    if (!subscriberId) {
      console.error("❌ subscriber_id is missing.");
      return;
    }
    const response = await axios.get(` /composite-backend/internal/ui/rules/get-ruleset?name=${name}&subscriber_id=${subscriberId}`);
    console.log("Fetched ruleset data:", response.data);

    const { ruleset, rules } = response.data;

    setRuleset({
      name: ruleset.ruleset_name || "",
      description: ruleset.description || "",
      action: ruleset.action || "",
    });

    setRulesInRuleset(
      rules.map((rule) => ({
        id: rule.id,
        name: rule.rule_name,
        description: rule.rule_description,
        action: rule.rule_action,
      }))
    );
    console.log("Updated rulesInRuleset state:", rulesInRuleset);


    setInitialState({
      //availableRules: [...rules],
      rulesInRuleset: [...rules],
    });
  } catch (error) {
    console.error(`Error fetching ruleset "${name}":`, error);
    alert("Failed to fetch ruleset details. Please try again.");
  }
};

  // Initialize form for create mode
  const initializeCreateMode = () => {
    setRuleset({ name: "", description: "", action: "" });
    setRulesInRuleset([]);
    setInitialState({ availableRules: [], rulesInRuleset: [] });
  };

  const fetchAvailableRules = async () => {
  try {
    const token = localStorage.getItem("access_token");  // ✅ Ensure token is retrieved
    if (!token) {
      console.error("❌ No access token found.");
      return;
    }

    const subscriberId = await getSubscriberId();
    if (!subscriberId) {
      console.error("❌ subscriber_id is missing.");
      return;
    }

    // ✅ Define API endpoint
    const endpoint = rulesetName
      ? ` /composite-backend/internal/ui/rules/get-available-rules?ruleset_name=${rulesetName}&subscriber_id=${subscriberId}`
      : ` /composite-backend/internal/ui/rules/list-rules?subscriber_id=${subscriberId}`;

    // ✅ Fetch data before filtering
    const response = await axios.get(endpoint, {
      withCredentials: true,  // ✅ Ensure cookies are sent
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,  // ✅ Send token
      }
    });

    console.log("Fetched available rules from backend:", response.data);

    // ✅ Filter only in edit mode after fetching the response
    const filteredRules = rulesetName
      ? response.data.filter((rule) => !rulesInRuleset.some((r) => r.id === rule.rule_id))
      : response.data;

    setAvailableRules(filteredRules);
  } catch (error) {
    console.error("❌ Error fetching available rules:", error);
  }
};




  const resetChanges = () => {
    if (window.confirm("Are you sure? All unsaved changes will be lost.")) {
      setAvailableRules([...initialState.availableRules]);
      setRulesInRuleset([...initialState.rulesInRuleset]);
      setSelectedAvailableRules([]);
      setSelectedRulesInRuleset([]);
      setRuleset({ name: "", description: "", action: "" });
    }
  };

  const saveChanges = async () => {
    if (!ruleset.name.trim()) {
      alert("Ruleset Name is required.");
      return;
    }
    if (!ruleset.description.trim()) {
      alert("Description is required.");
      return;
    }
    if (!ruleset.action.trim()) {
      alert("Action is required.");
      return;
    }
    if (rulesInRuleset.length === 0) {
      alert("At least one rule must be associated with the ruleset.");
      return;
    }

    try {
      
            const subscriberId = await getSubscriberId();  // ✅ Ensure subscriber_id is retrieved
	    if (!subscriberId) {
	      console.error("❌ subscriber_id is missing.");
	      return;
	    }

            console.log("✅ Sending subscriber_id:", subscriberId);
	      // Extract rule names from rulesInRuleset
	    const ruleNames = rulesInRuleset.map((rule) => rule.name);

	    // Fetch rule IDs from the backend
	    console.log("Fetching rule IDs for rules:", ruleNames);
	    const ruleIdsResponse = await axios.post(" /composite-backend/internal/ui/rules/get-rule-ids", {
	      rule_names: ruleNames,
	      subscriber_id: subscriberId,  // ✅ Ensure subscriber_id is included
	    });

	    const ruleIds = ruleIdsResponse.data.rule_ids.map((rule) => rule.id);

	    // Debug extracted rule IDs
	    console.log("Extracted rule IDs:", ruleIds);



      // Send the ruleset data to the save-ruleset endpoint
      await axios.post(" /composite-backend/internal/ui/rules/save-ruleset", {
        id: ruleset.id, // Send the ruleset ID if available (for updates)
        ruleset_name: ruleset.name,
        description: ruleset.description,
        action: ruleset.action,
        rule_ids: ruleIds, // Include associated rule IDs
        subscriber_id: subscriberId,  // ✅ Ensure subscriber_id is included
      });
      alert("Ruleset saved successfully!");
      fetchRuleset(ruleset.name); // Refresh the ruleset data after saving
      // Redirect after 5 seconds
    setTimeout(() => {
      navigate("/rulesets"); // Replace "/ruleset-listing" with your actual route
    }, 5000);
     
    } catch (error) {
      console.error("Error saving ruleset:", error);
      alert("Failed to save ruleset. Please try again.");
    }
  };

  const handleCheckboxChange = (ruleId, list, setList) => {
  console.log(`Toggling rule ID: ${ruleId}`);
  console.log("Before toggle:", list);
  
  if (!ruleId) {
    console.error("Invalid ruleId:", ruleId);
    return;
  }

  setList((prev) => {
    const updatedList = prev.includes(ruleId)
      ? prev.filter((id) => id !== ruleId) // Remove ruleId
      : [...prev, ruleId]; // Add ruleId

    console.log("After toggle:", updatedList);
    return updatedList;
  });
};


  const handleAddSelectedRules = () => {
    const addedRules = availableRules.filter((rule) =>
      selectedAvailableRules.includes(rule.id)
    );
    setRulesInRuleset((prev) => [...prev, ...addedRules]);
    setAvailableRules((prev) =>
      prev.filter((rule) => !selectedAvailableRules.includes(rule.id))
    );
    setSelectedAvailableRules([]);
  };

  const handleRemoveSelectedRules = () => {
    const removedRules = rulesInRuleset.filter((rule) =>
      selectedRulesInRuleset.includes(rule.id)
    );
    setAvailableRules((prev) => [...prev, ...removedRules]);
    setRulesInRuleset((prev) =>
      prev.filter((rule) => !selectedRulesInRuleset.includes(rule.id))
    );
    setSelectedRulesInRuleset([]);
  };

  const filteredAvailableRules = availableRules.filter((rule) =>
    rule.name.toLowerCase().includes(searchAvailable.toLowerCase())
  );

  const filteredRulesInRuleset = rulesInRuleset.filter((rule) =>
    rule.name.toLowerCase().includes(searchInRuleset.toLowerCase())
  );
  
 
  // ✅ Define styles for buttons
  const buttonStyles = {
    actionButtons: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      marginTop: "20px",
    },
    buttonBase: {
      fontSize: "16px",
      padding: "12px 20px",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background 0.3s ease-in-out, transform 0.2s",
      fontWeight: "bold",
      textTransform: "uppercase",
    },
    cancelButton: {
      backgroundColor: "#ff4d4d",
      color: "white",
    },
    cancelButtonHover: {
      backgroundColor: "#cc0000",
      transform: "scale(1.05)",
    },
    submitButton: {
      backgroundColor: "#007BFF",
      color: "white",
    },
    submitButtonHover: {
      backgroundColor: "#0056b3",
      transform: "scale(1.05)",
    },
  };

  return (
    <div>
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#007BFF",
          padding: "16px",
          color: "#FFF",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src="/assets/b4d48a3e-5b5a-4392-ab30-df41c0a4471a.jpg"
            alt="Idenza Logo"
            style={{ width: "50px", marginRight: "10px" }}
          />
          <h1 style={{ margin: "0" }}>Idenza</h1>
        </div>
        <h2 style={{ textAlign: "center", flexGrow: 1 }}>Manage Rule Sets</h2>
      </div>

      {/* Ruleset Form */}
      <div style={{ padding: "16px", display: "flex", gap: "16px", flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 300px" }}>
          <label>Ruleset Name</label>
          <input
            type="text"
            value={ruleset.name}
            onChange={(e) => setRuleset((prev) => ({ ...prev, name: e.target.value }))}
            placeholder="Enter Ruleset Name"
            style={{
              padding: "8px",
              width: "100%",
              borderRadius: "4px",
              border: "1px solid #D1D5DB",
            }}
          />
        </div>
        <div style={{ flex: "2 1 300px" }}>
          <label>Description</label>
          <input
            type="text"
            value={ruleset.description}
            onChange={(e) =>
              setRuleset((prev) => ({ ...prev, description: e.target.value }))
            }
            placeholder="Enter Description"
            style={{
              padding: "8px",
              width: "100%",
              borderRadius: "4px",
              border: "1px solid #D1D5DB",
            }}
          />
        </div>
        <div style={{ flex: "1 1 200px" }}>
          <label>Action</label>
          <select
            value={ruleset.action}
            onChange={(e) => setRuleset((prev) => ({ ...prev, action: e.target.value }))}
            style={{
              padding: "8px",
              width: "100%",
              borderRadius: "4px",
              border: "1px solid #D1D5DB",
            }}
          >
            <option value="">Select Action</option>
            {allowedActions.map((action, index) => (
              <option key={index} value={action}>
                {action}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Main Content */}
      <div className="manage-rulesets">
        <div className="ruleset-container">
          {/* Available Rules Section */}
          <div className="rules-section">
            <h2>Available Rules</h2>
            <input
              type="text"
              placeholder="Search rules..."
              value={searchAvailable}
              onChange={(e) => setSearchAvailable(e.target.value)}
              className="search-box"
            />
            <table className="rules-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={
                        filteredAvailableRules.length > 0 &&
                        selectedAvailableRules.length === filteredAvailableRules.length
                      }
                      onChange={(e) =>
                        setSelectedAvailableRules(
                          e.target.checked
                            ? filteredAvailableRules.map((rule) => rule.id)
                            : []
                        )
                      }
                    />
                  </th>
                  <th>Name</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {filteredAvailableRules.map((rule) => (
                  <tr key={rule.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedAvailableRules.includes(rule.id)}
                        onChange={() =>
                          handleCheckboxChange(
                            rule.id,
                            selectedAvailableRules,
                            setSelectedAvailableRules
                          )
                        }
                      />
                    </td>
                    <td>{rule.name}</td>
                    <td>{rule.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button
              onClick={handleAddSelectedRules}
              className="action-button add-button"
              disabled={selectedAvailableRules.length === 0}
            >
              Add Selected
            </button>
          </div>

          {/* Rules in Ruleset Section */}
          <div className="rules-section">
            <h2>Rules in Ruleset</h2>
            <input
              type="text"
              placeholder="Search rules..."
              value={searchInRuleset}
              onChange={(e) => setSearchInRuleset(e.target.value)}
              className="search-box"
            />
            <table className="rules-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={
                        filteredRulesInRuleset.length > 0 &&
                        selectedRulesInRuleset.length === filteredRulesInRuleset.length
                      }
                      onChange={(e) =>
                        setSelectedRulesInRuleset(
                          e.target.checked
                            ? filteredRulesInRuleset.map((rule) => rule.id)
                            : []
                        )
                      }
                    />
                  </th>
                  <th>Name</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {filteredRulesInRuleset.map((rule) => (
                  <tr key={rule.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRulesInRuleset.includes(rule.id)}
                        onChange={() =>
                          handleCheckboxChange(
                            rule.id,
                            selectedRulesInRuleset,
                            setSelectedRulesInRuleset
                          )
                        }
                      />
                    </td>
                    <td>{rule.name}</td>
                    <td>{rule.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button
              onClick={handleRemoveSelectedRules}
              className="action-button remove-button"
              disabled={selectedRulesInRuleset.length === 0}
            >
              Remove Selected
            </button>
          </div>
        </div>

    
      <div style={buttonStyles.actionButtons}>
        <button
          onClick={resetChanges}
          style={{
            ...buttonStyles.buttonBase,
            ...(isCancelHovered ? buttonStyles.cancelButtonHover : buttonStyles.cancelButton),
          }}
          onMouseEnter={() => setCancelHovered(true)}
          onMouseLeave={() => setCancelHovered(false)}
        >
          Cancel
        </button>
        <button
          onClick={saveChanges}
          style={{
            ...buttonStyles.buttonBase,
            ...(isSubmitHovered ? buttonStyles.submitButtonHover : buttonStyles.submitButton),
          }}
          onMouseEnter={() => setSubmitHovered(true)}
          onMouseLeave={() => setSubmitHovered(false)}
        >
          Submit
        </button>
      </div>
      </div>

      {/* Footer Section */}
      <div
        style={{
          backgroundColor: "#007BFF",
          color: "#FFF",
          textAlign: "center",
          padding: "16px",
        }}
      >
        <p>Manage Rule Sets © 2025</p>
      </div>
    </div>
  );
};

export default ManageRuleSets;

